module.exports = __webpack_public_path__ + "static/media/vtex-manual-import2.db2eb13d.png";